import dynamic from "next/dynamic";
import Head from "next/head";
import { useRouter } from "next/router";

import classNames from "classnames";

import CustomCard from "components/CustomCard";
import { profileUrl } from "components/ProfilePageLayout";
import { useApi } from "hooks/useApi";

const ProfilePageMembersList = dynamic(
  () => import("./ProfilePageMembersList")
);

type ProfilePageTeamProps = {};

const ProfilePageTeam = ({}: ProfilePageTeamProps) => {
  const router = useRouter();
  const slug = router.query.slug as string;

  const isCompany = router.route.startsWith("/companies/[slug]");

  const { data: profile } = useApi(profileUrl(slug, isCompany));
  const { name } = profile;

  const title = `${name} - Team`;
  const description = profile.isInsightProvider
    ? `View ${name} team on Smartkarma`
    : "";

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Head>
      <CustomCard
        className={classNames(
          "mx-0 mt-0 rounded-none",
          "md:rounded-xl md:mt-[40px]"
        )}
      >
        <ProfilePageMembersList />
      </CustomCard>
    </>
  );
};

export default ProfilePageTeam;
